import './LoadingScreen.css';

const LoadingScreen = ({ compact = false, label = 'Curating your next obsession' }) => (
  <div className={`loading-screen ${compact ? 'compact' : ''}`} role="status" aria-live="polite">
    <div className="loading-aura" />
    <img src="/hedone.png" alt="" className="loading-logo" />
    <div className="loading-copy">
      <strong>HEDONE</strong>
      <span>{label}</span>
    </div>
    <div className="loading-track"><i /></div>
  </div>
);

export default LoadingScreen;
